import { Getters } from 'vuex-smart-module';
import RetroBonusesState from './state';

export default class RetroBonusesGetters extends Getters<RetroBonusesState> {}
